import { MODULE as PARENT } from '../constants'

export const KEY = 'pages'
export const MODULE = [...[PARENT], KEY]

export const FETCH_PAGE = `${MODULE.join('/')}-fetch`
export const CLEAR_PAGE = `${MODULE.join('/')}-clear`
